import DiveForm from '../components/DiveForm'

const CreateDive = () => {
  return <DiveForm />
}

export default CreateDive
